import {IComponentOptions, IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {FavorittRessurs} from "felles/tjenester/ressurser/FavorittRessurs";
import {Kontekst} from "felles/tjenester/Kontekst";

const css = require('./favoritt.scss');

export function registrerFavorittKomponent(angular: IModule) {
    angular
        .component('wmFavoritt', favorittKomponentDef())
}

export function favorittKomponentDef(): IComponentOptions {
    return {
        bindings: {favoritt: '<', vedSlettet: '&',},
        controller: FavorittKontroller.forInjisering(),
        template: require('./favoritt.html')
    };
}

export class FavorittKontroller implements IController {
    static forInjisering() {
        return [
            Kontekst.regNavn,
            FavorittRessurs.regNavn,
            WebNavigasjon.regNavn,
            FavorittKontroller
        ]
    }

    constructor(private kontekst: Kontekst,
                private favorittRessurs: FavorittRessurs,
                private webNavigasjon: WebNavigasjon) {
    }

    favoritt: l.FavorittModell; //satt via bindings
    vedSlettet: (arg: { favoritt: l.FavorittModell; }) => void; //satt via bindings
    gruppefarge: string; //satt i onchange
    typer = l.FavorittType;

    erMoete() {
        return this.favoritt.type == l.FavorittType.moete;
    }

    erSak() {
        return this.favoritt.type == l.FavorittType.sak;
    }

    erSaksdokument(){
        return this.favoritt.type == l.FavorittType.dokument
            && this.favoritt.assosiertEntitetBeskrivelse.dokumentType !== l.DokumentType.arkivdokument;
    }

    erArkivdokument(){
        return this.favoritt.type == l.FavorittType.dokument
            && this.favoritt.assosiertEntitetBeskrivelse.dokumentType === l.DokumentType.arkivdokument;
    }

    erOppgave() {
        return this.favoritt.type == l.FavorittType.oppgave;
    }

    erBeslutning() {
        return this.favoritt.type == l.FavorittType.beslutning;
    }

    gaaEntitet(){
        //dokument gjør request, arkivdokument gjør en request mindre
        if (this.erArkivdokument())
            this.webNavigasjon.gåTilArkivdokumentKnyttetTilDokument(this.favoritt.assosiertEntitet.id);
        else
            this.webNavigasjon.gåTilEntitetRef(this.favoritt.assosiertEntitet);
    }

    slett() {
        this.favorittRessurs.slettSomFavoritt(this.favoritt.type, this.favoritt.assosiertEntitet.id).$promise
            .then(favoritter => this.vedSlettet({favoritt: this.favoritt}));

    }

    $onChanges(changes: IOnChangesObject) {
        this.gruppefarge = this.kontekst.finnAutentiserteGruppe(this.favoritt.gruppeId).farge;
    }


}
